import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Toast } from '@deque/cauldron-react';

interface FeedbackToastProps {
  /* The text to display in the toast */
  text: string;
  /* The link to the survey */
  surveyLink: string;
  /* Whether or not the toast should have focus on load, defaults to false */
  hasFocus?: boolean;
}

const FeedbackToast: React.FC<FeedbackToastProps> = ({
  text,
  surveyLink,
  hasFocus = false
}) => {
  const { t } = useTranslation();

  return (
    <Toast type="info" show dismissible={false} focus={hasFocus}>
      {text}
      &nbsp;
      <a href={surveyLink} target="_blank" rel="noopener noreferrer">
        {t('Send Feedback')}
        <Icon type="external-link" label={t('opens in a new window')} />
      </a>
    </Toast>
  );
};

export default FeedbackToast;
